import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#fff";
function DCR({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M11.142 13.215h3.315a2.24 2.24 0 002.233-2.247 2.24 2.24 0 00-2.233-2.246h-1.055l-2.26-1.972h3.315a4.2 4.2 0 014.116 3.409 4.224 4.224 0 01-2.534 4.717l2.613 2.282H15.66zm1.618-2.52H9.445a2.24 2.24 0 00-2.234 2.246 2.24 2.24 0 002.234 2.246H10.5l2.259 1.972H9.445a4.2 4.2 0 01-4.116-3.408 4.224 4.224 0 012.534-4.718L5.25 6.75h2.994z" /><path  d="M11.19 13.26h3.316a2.24 2.24 0 002.233-2.247 2.24 2.24 0 00-2.233-2.246H13.45l-2.26-1.972h3.315a4.2 4.2 0 014.116 3.41 4.224 4.224 0 01-2.534 4.717l2.613 2.281h-2.993zm1.619-2.52H9.494a2.24 2.24 0 00-2.234 2.246 2.24 2.24 0 002.234 2.246h1.055l2.259 1.973H9.494a4.2 4.2 0 01-4.116-3.41 4.224 4.224 0 012.534-4.717L5.3 6.795h2.994z" /></Svg>;
}
DCR.DefaultColor = DefaultColor;
export default DCR;